module.exports = __webpack_public_path__ + "img/OfflineBoltOutlined.59c28860.svg";